module.exports = {
	"AlsoToday": "Anche oggi",
	"Archive": "Archivio",
	"ClickHereForMoreInfo": "Cliccare qui per ulteriori informazioni",
	"ClientWebServiceNotResponding": "Il servizio di autentificazione non è disponibile.",
	"Confirm": "Confermare",
	"Digital": "Digitale",
	"DigitalVersion": "Versione digitale",
	"Edition": "Edizione",
	"Help": "Aiuto",
	"HorsSeries": "Prodotti speciali",
	"LoadingNewspaperPleaseWait": "Caricamento del giornale in corso, attendere prego",
	"LogIn": "Login",
	"LogInWith": "Login con:",
	"MaximumDeviceNumberReached": "Il numero massimo di dispositivi è raggiunto per questa pubblicazione.",
	"ModernBrowserRequired": "Per leggere l'edizione digitale di questo giornale avete bisogno di Internet Explorer 9 o superiore. Si raccomanda aggiornare il browser o caricare un altro browser (Chrome, Firefox, …)",
	"More": "Di più",
	"Newspaper": "Giornale",
	"NewspaperCurrentlyUnavailable": "Il giornale non può essere aperto al momento. Prego riprovare più tardi.",
	"NoDigitalAccess": "Non avete un accesso digitale",
	"OK": "OK",
	"Paper": "Cartacea",
	"PaperVersion": "Versione cartacea",
	"Password": "Password",
	"PleaseFillInAllFields": "Per favore compilare tutti i campi",
	"Promospot": "Promospot",
	"ReadingPreference": "Preferenza di lettura",
	"Read": "Leggere",
	"ReadTheNewspaper": "Leggi il giornale",
	"Register": "Clicca qui per registrarti",
	"SelectEdition": "Selezionare un'edizione",
	"SignIn": "Collegarsi",
	"SignOut": "Scollegarsi",
	"Subscription": "Abbonamento",
	"Supplements": "Supplementi",
	"SSOValidationFailed": "L'autenticazione automatica ha fallito.",
	"TemporarilyUnavailable": "Non disponibile in questo momento",
	"TheUsernameAndOrPasswordIsIncorrect": "Nome utente o password non sono validi",
	"UnknownError": "Si è verificato un errore sconosciuto",
	"UnknownUser": "Il nome dell'utente non è giusto",
	"Username": "Nome utente / Indirizzo e-mail",
	"ValidationFailed": "Il sistema di autenticazione non è al momento disponibile.",
	"YourSessionHasExpired": "La vostra sessione è scaduta",
	"download": "Scaricare",
	"downloadPDFerror": "Il limite di caricamento per questa edizione è raggiunto.",
	"Proceed": "Continuare",
	"ForgotPassword": "Dimenticato la password",
	"Cancel": "Annullare",
	"moment": "it",
	"Extra": "Prodotti speciali",
	"ChooseRegion": "Selezionare una regione",
	"downloadingNewsPaper": "Caricamento del vostro giornale in corso, grazie per la pazienza.",
	"CookieConfirmButton": "OK",
	"CookieLinkText": "Maggiori informazioni",
	"CookieInformText": "Questo sito web utilizza i cookie. Utilizzando questo sito web accettate l'utilizzo di cookie.",
	"home": "Home",
	"recently": "Edizioni più recenti",
	"supplements": "Supplementi",
	"extras": "Prodotti speciali",
	"inforAndExtras": "Informazioni e extra",
	"jumpBack": "Indietro",
	"regions": "Regioni",
	"settings": {
		"title": "Impostazioni",
		"voucher": {
			"title": "Buono",
			"inactive": "Inattivo",
			"active": "Attivo fino al",
			"instructions": "Inserire il vostro voucher qui sotto per attivare l'accesso temporaneo.",
			"placeholder": "Inserire il voucher qui",
			"validate": "Riscatta il mio voucher",
			"errors": {
				"expired": "Il vostro voucher è scaduto. Si prega di contattare il servizio clienti.",
				"invalid": "Il vostro voucher non è valido. Inserire un voucher valido o contattare il servizio clienti se il problema persiste.",
				"alreadyRedeemed": "Il vostro voucher è già stato riscattato. Inserire un voucher valido o contattare il servizio clienti se il problema persiste.",
				"generic": "Qualcosa è andato storto. Inserire un voucher valido o contattare il servizio clienti se il problema persiste."
			}
		}
	},
	"sharingLandingBanner": {
		"text": "Ti piace questo articolo? Iscriviti oggi per saperne di più o accedi se sei già abbonato!",
		"signup": "Abbonati",
		"login": "Accedi"
	},
	"region": "Regione",
	"login": "Login",
	"logout": "Logout",
	"help": "Aiuto",
	"about": "A proposito",
	"disclaimer": "Disclaimer",
	"account": "Utente",
	"accountLoggedIn": "Collegato",
	"accountLoggedInInfo": "Siete collegato.",
	"accountLoggedWithInfo": "Si è attualmente connessi con",
	"accountLoggedOut": "Non collegato",
	"version": "Versione",
	"platformversion": "Versione piattaforma",
	"uuid": "UUID",
	"editor": "Editore",
	"developer": "Creatore",
	"downloading": "Caricando...",
	"journal": "Giornale",
	"alsoRead": "Leggere anche",
	"alsoWatch": "Guardare anche",
	"alsoSee": "Vedere anche",
	"authorising": "Autorizzare...",
	"noInternetNoVideo": "Per visualizzare questo video è necessario aver effettuato il login.",
	"notSupported": "Questo sito può solo essere visualizzato in browser aggiornati. Aggiornate il vostro browser oppure caricate Chrome.",
	"printImage": "Immagine",
	"printText": "Testo",
	"print": "Stampare",
	"fullPdfDownload": "Intera edizione",
	"pagePdfDownload": "Pagina attuale",
	"landscapeToggle": "Modo orizzontale",
	"singlePage": "Visualizzazione di una pagina",
	"singlePageShort": "una pagina",
	"doublePage": "Visualizzazione di più pagine",
	"doublePageShort": "più pagine",
	"passwordForgottenLoadingText": "Si prega di attendere mentre la pagina si sta caricando",
	"landscapeToggleEExplanation": "Per la lettura in modo orizzontale, si può scegliere tra visualizzare una pagina a larghezza intera o visualizzare più pagine.",
	"PleaseFillInAValidEmail": "Si prega di inserire un indirizzo e-mail valido.",
	"LeftPage": "Pagina a sinistra",
	"RightPage": "Pagina a destra",
	"Sorry": "Scusa!",
	"close": "Chudere",
	"pdfDownloadTooltip": "Scaricare",
	"printLeftPage": "Pagina a sinistra",
	"printRightPage": "Pagina a destra",
	"printSinglePage": "Pagina attuale",
	"cropPrint": "Stampare",
	"cropPrintInstruction": "Per stampare una pagina intera, cliccate su \"Stampa\".<br>Per stampare una parte della pagina o un articolo specifico, ridimensionare il rettangolo blu cliccando e trascinando gli angoli intorno alla porzione che si desidera stampare.",
	"cropPrintTitle": "Stampare",
	"logoTooltip": "",
	"readerLogoTooltip": "",
	"openCMPSetting": "Le mie impostazioni di privacy",
	"dataPolicy": "Dati personali",
	"privacyPolicy": "Política de privacidad",
	"singlePageMode": "Modalità una pagina",
	"doublePageMode": "Modalità due pagine",
	"readingModeToggle": "Modalità di lettura",
	"E1": "I sistemi di autenticazione non sono al momento raggiungibili. Prego riprovare più tardi.",
	"E2": "",
	"E3": "Il sistema di autenticazione non è al momento disponibile.",
	"E4": "I sistemi di autenticazione non sono al momento raggiungibili. Prego riprovare più tardi.",
	"E5": "Non avete accesso all'offerta digitale",
	"E6": "Credenziali invalide. Controllate la vostra email/password e riprovate.",
	"E7": "Credenziali invalide. Controllate la vostra email/password e riprovate.",
	"E8": "Il giornale non può essere aperto al momento. Prego riprovare più tardi",
	"E9": "I sistemi di autenticazione non sono al momento raggiungibili. Prego riprovare più tardi.",
	"E11": "Avete raggiunto il numero massimo di downloads per il vostro abbonamento",
	"E13": "I sistemi di autenticazione non sono al momento raggiungibili. Prego riprovare più tardi.",
	"E15": "I sistemi di autenticazione non sono al momento raggiungibili. Prego riprovare più tardi.",
	"E16": "",
	"E17": "Il sistema di autenticazione non è al momento disponibile.",
	"E18": "Il sistema di autenticazione non è al momento disponibile.",
	"E20": "Il sistema di autenticazione non è al momento disponibile.",
	"E21": "Il sistema di autenticazione non è al momento disponibile.",
	"E24": "Il vostro abbonamento non ha diritti sufficienti per leggere questa publicazione",
	"E25": "Avete raggiunto il limite massimo di accessi contemporanei per questo abbonamento. Prego riprovare più tardi.",
	"E26": "Le credenziali d'accesso fornite non possono essere verificate. Provate di nuovo oppure contattate il servizio clienti.",
	"pageDoesNotExist": "La pagina non esiste",
	"returnToKiosk": "Ritorno al chiosco &#62;",
	"error404": "Errore 404"
};


//////////////////
// WEBPACK FOOTER
// ./src/common/i18n/it_IT.json
// module id = 423
// module chunks = 0 1